const namespaced = true

const state = {
  data: [],
}

const getters = {
  dialogs(state) {
    return state.data
  },
  getDialogByKey: state => key => {
    return state.data.find(dialog => dialog.key == key)
  }
}

const actions = {
  addDialog({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('addDialog', {
        ...Object.assign({
          layout: 'default',
          title: null,
          message: null,
          icon: null,
          actions: [],
          onOpen: null,
        }, payload),
        promise: { resolve, reject },
        key: _.uniqueId(),
      })
    })
  },
  removeDialog({ commit }, key) {
    commit('removeDialog', key)
  },
}

const mutations = {
  addDialog(state, data) {
    state.data.push(data)
  },
  removeDialog(state, key) {
    let index = state.data.findIndex(dialog => dialog.key == key)
    if (index != -1) {
      state.data.splice(index, 1)
    }
  },
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/dialog.js